export const headerConfig = {
  headerTitle: 'Work Permits',
  headerDescription: 'List of Work Permits',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
